import { createStyles } from '@mantine/core';
import { useMemo } from 'react';
import type { ITest } from '../../../api';
import {
	ReadOnlyBadgeRender,
	RelativeTimeRender,
	RenderWithIntegrationLogo,
} from '../../../components/TableV2/render';
import type { ExtendedDataTableColumn } from '../../../components/TableV2/types';

const useStyles = createStyles({});

export const useColumns = (): ExtendedDataTableColumn<ITest>[] => {
	const { theme } = useStyles();

	const columns: ExtendedDataTableColumn<ITest>[] = useMemo(
		() => [
			{
				titleLabel: 'Test',
				accessor: 'title',
				width: theme.other.space[60], // 240px
				render: (record: ITest) => (
					<RenderWithIntegrationLogo
						integrationId={record.integration}
						textContent={record.title}
					/>
				),
			},
			{
				titleLabel: 'Columns',
				accessor: 'columns',
			},
			{
				titleLabel: 'Status',
				accessor: 'latest_run.status',
				render: (record: ITest) => (
					<ReadOnlyBadgeRender
						nilOption={{
							variant: 'default',
							label: 'Not run',
							option: '', // This value is redundant because latest_run will be null if the test has not been run
						}}
						options={[
							{
								variant: 'success',
								label: 'Success',
								option: 'pass',
							},
							{
								variant: 'success',
								label: 'Success',
								option: 'success',
							},
							{
								variant: 'critical',
								label: 'Fail',
								option: 'fail',
							},
							{
								variant: 'critical',
								label: 'Error',
								option: 'error',
							},
						]}
						record={record}
						field="latest_run.status"
					/>
				),
			},
			{
				titleLabel: 'Last run',
				accessor: 'latest_run.run_created_at',
				render: (record: unknown) => (
					<RelativeTimeRender
						record={record}
						field="latest_run.run_created_at"
					/>
				),
			},
		],
		[theme.other.space]
	);

	return columns;
};
